import { render, staticRenderFns } from "./modalDuplicarParametros.vue?vue&type=template&id=8d1048f8"
import script from "./modalDuplicarParametros.vue?vue&type=script&lang=js"
export * from "./modalDuplicarParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports